<app-header-title>
  <span title>{{'publicsetting.durationWork'|translate}}</span>
</app-header-title>


<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
    [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
    [showBorders]="false" [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false"
    (onRowUpdating)="updateRow($event)" (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)" (onInitNewRow)="onInitNewRow($event)">

    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
      [texts]="button">
      <dxo-popup [title]="addpopup" [showTitle]="true" [width]="700" [height]="525" [hideOnOutsideClick]="true">
      </dxo-popup>

      <dxo-form labelMode="floating" labelLocation="top"></dxo-form>

      <dxo-texts [addRow]="addrowfun('publicsetting.durationWork')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>


    <dxo-paging [pageSize]="10"> </dxo-paging> <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full"
      [showPageSizeSelector]="true" [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <!-- <dxi-column
        dataField="id" [visible]="false"
        [width]="90"
        [hidingPriority]="2">
      </dxi-column> -->
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.name'|translate}}" [hidingPriority]="8">
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>


      <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!" [validationCallback]="validateAsync">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="numberOfHours" dataType="number" caption="{{'tableinfo.numberOfHours'|translate}}">
      <dxi-validation-rule type="range" message="{{'errors.between'|translate}}" [min]="0" [max]="24">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="attendanceFromHour" caption="{{'tableinfo.attendanceFromHour'|translate}}"
      dataType="datetime" [editorOptions]="{type: 'time'}" format='shortTime' cellTemplate="dateCell">
    </dxi-column>
    <div *dxTemplate="let cellData of 'dateCell'">
      {{cellData.value | date: 'shortTime'}}
    </div>

    <dxi-column dataField="leaveToHour" caption="{{'tableinfo.leaveToHour'|translate}}" dataType="datetime"
      [editorOptions]="{ type: 'time' }" format='shortTime' cellTemplate="dateCell2">
      <dxi-validation-rule type="custom" [validationCallback]="validateNumber" [reevaluate]="true"
        message="{{'errors.attendance'|translate}}"></dxi-validation-rule>
    </dxi-column>

    <div *dxTemplate="let cellData of 'dateCell2'">
      {{cellData.value | date: 'shortTime'}}
    </div>

    <dxi-column dataField="isFixedPeriod" [setCellValue]="isFixedPeriod"
      caption="{{'tableinfo.isFixedPeriod'|translate}}">
    </dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>

    </dxi-column>
    <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
</div>